import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    content: {
      zIndex: 9,
      height: '100%',
      overflowY: 'scroll',
      padding: 15,
      display: 'flex',
      flexDirection: 'column',
      scrollBehavior: 'smooth',
      '&::-webkit-scrollbar': {
        width: theme.shape.scrollSize,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.scroll,
        borderRadius: theme.shape.scrollRadius,
      },
    },
    loadingSection: {
      display: 'flex',
      justifyContent: 'center',
      padding: 15,
    },
    usefulLink: {
      display: 'block',
      marginBottom: 16,
      textDecoration: 'underline',
    },
  }))

export default useStyles
